import { DEV } from 'solid-js'
import { Object3D } from 'three'
import { next, sample } from '../../../core/rng/index'
import type { RNGConfig } from '../../../core/rng/RNGConfig.type'
import { HALF_PI } from '../../../core/util/math/Math'
import assertClassInDev from '../../../ldsh/assertClassInDev'
import { Y_AXIS_VECTOR } from '../../consts'
import { appGltfLoader } from '../../fn/appGltfLoader'
import creaseGeometryNormalsRecursive from '../../fn/creaseGeometryNormalsRecursive'
import { Quaternius_UltimateNaturePack_Cactus_Cactus_1_GLTF_Model, Quaternius_UltimateNaturePack_Cactus_Cactus_2_GLTF_Model, Quaternius_UltimateNaturePack_Cactus_Cactus_3_GLTF_Model, Quaternius_UltimateNaturePack_Cactus_Cactus_4_GLTF_Model, Quaternius_UltimateNaturePack_Cactus_Cactus_5_GLTF_Model, Quaternius_UltimateNaturePack_Cactus_CactusFlowers_3_GLTF_Model } from '../../gltf_models.generated'
// import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

const modelPool: Readonly<Array<string>> = [
  // Spikey
  Quaternius_UltimateNaturePack_Cactus_Cactus_1_GLTF_Model,
  // 4 Arms
  Quaternius_UltimateNaturePack_Cactus_Cactus_2_GLTF_Model,
  // 2 Arms
  Quaternius_UltimateNaturePack_Cactus_Cactus_3_GLTF_Model,
  // 4 Forks
  Quaternius_UltimateNaturePack_Cactus_Cactus_4_GLTF_Model,
  // 2 Forks
  Quaternius_UltimateNaturePack_Cactus_Cactus_5_GLTF_Model,
  // 2 Arms + Pink Flower
  Quaternius_UltimateNaturePack_Cactus_CactusFlowers_3_GLTF_Model,
] as const

/**
 * Builds and returns a low‑poly cactus Mesh or Group.
 * Call it repeatedly to sprinkle random cacti around your desert.
 */
export default function createEntityQuaterniusCactusMesh(
  rng: RNGConfig
): Promise<Object3D> {
  return new Promise((resolve) => {
    const model = sample(modelPool, rng)!
    appGltfLoader.load(model, function (ModelObj) {
      // console.log('ModelObj', ModelObj)
      const mesh = ModelObj.scene.children[0]
      if (DEV) {
        assertClassInDev(mesh, Object3D)
      }
      mesh.rotateX(HALF_PI)
      mesh.rotateOnAxis(Y_AXIS_VECTOR, next(rng) * 2)
      // console.log(mesh)
      // printObjectHierarchy(mesh)
      creaseGeometryNormalsRecursive(mesh)
      resolve(mesh)
    })
  })
}
